import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { omit, uniqBy } from "lodash";

const ALL = {
  label: "All",
  id: "all",
};

export function ProcessGroupsPicker({
  allProcessesLabeled,
  allGroupsLabeled,
  selectedGroups,
  setSelectedGroups,
  selectedProcesses,
  setSelectedProcesses,
}: {
  allProcessesLabeled: {
    label: string;
    id: string;
  }[];
  allGroupsLabeled: {
    label: string;
    id: string;
    processIds: string[];
  }[];
  selectedGroups: {
    label: string;
    id: string;
    processIds: string[];
  }[];
  setSelectedGroups: React.Dispatch<
    React.SetStateAction<
      {
        label: string;
        id: string;
        processIds: string[];
      }[]
    >
  >;
  selectedProcesses: {
    label: string;
    id: string;
  }[];
  setSelectedProcesses: React.Dispatch<
    React.SetStateAction<
      {
        label: string;
        id: string;
      }[]
    >
  >;
}) {
  const areAllSelected =
    selectedProcesses.length === allProcessesLabeled.length;
  const doesIncludeAllGroup = allGroupsLabeled.some(p => p.label === ALL.label);
  return (
    <Autocomplete
      fullWidth={true}
      multiple={true}
      getOptionLabel={option => option.label}
      options={[
        ...(doesIncludeAllGroup
          ? []
          : [
              {
                ...ALL,
                processIds: allProcessesLabeled.map(p => p.id),
              },
            ]),
        ...allGroupsLabeled,
      ]}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      value={selectedGroups}
      renderInput={params => (
        <TextField
          {...params}
          variant="standard"
          label="Process Groups"
          placeholder="Select process groups"
        />
      )}
      onChange={(_, newValue) => {
        if (newValue.find(option => option.id === ALL.id)) {
          setSelectedGroups(prev =>
            prev.length === allGroupsLabeled.length ? [] : allGroupsLabeled
          );
          setSelectedProcesses(prev =>
            prev.length === allProcessesLabeled.length
              ? []
              : allProcessesLabeled
          );
          return;
        }
        setSelectedGroups(newValue);
        const nextSelectedProcesses = newValue
          .reduce((acc, group) => {
            return [...acc, ...group.processIds];
          }, [] as string[])
          .map(pid => allProcessesLabeled.find(p => p.id === pid))
          .filter(pid => pid) as {
          label: string;
          id: string;
        }[];
        const nextSelectedProcessesUniq = uniqBy(
          nextSelectedProcesses,
          p => p.id
        );
        setSelectedProcesses(nextSelectedProcessesUniq);
      }}
      disableCloseOnSelect={true}
      renderOption={(props, option) => (
        <li key={option.id} {...omit(props, "key")}>
          <Checkbox
            icon={<CheckBoxOutlineBlank fontSize="small" />}
            checkedIcon={<CheckBox fontSize="small" />}
            style={{ marginRight: 8 }}
            checked={
              option.id === ALL.id
                ? areAllSelected
                : selectedGroups.some(p => p.id === option.id)
            }
          />
          {option.label}
        </li>
      )}
    />
  );
}
